import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { size as _size } from 'lodash';
import { i18nIntl, removeByRole } from '../../lib/ep.js';
import { ProfileModule } from '../ui_items/Module.js';
import { useOwner } from '../context/context.js';
import SimpleListOfItems from '../ui_items/SimpleListOfItems.js';


const PromoDatesResumee = (props) => {
	const owner = useOwner();

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = owner?.promotion?.Promotion ?? false;

	const is_multistage = promotion?.is_multistage ?? false;
	const is_basic	= (promotion.promo_type == '0') ? true : false;
	const role = props?.role ?? 'administrator';

	const languages	= props?.languages ?? [];
	const is_multilang = (languages.length > 1) ? true : false;
	const default_lang = promotion?.config?.main_language || promotion.default_locale;

	const date_format = 'MMM D YYYY, h:mm a';

	let promotion_countries;
	if(promotion.countries && typeof promotion.countries === 'Array') {
		promotion_countries = promotion.countries;
	} else {
		let _countries = promotion?.countries ?? '';
		promotion_countries = _countries.split(",");
	}

	let countries_arr = [];	
	if(promotion_countries.length>0){
		promotion_countries.map((country) => {
			if(!country) return null;
			countries_arr.push(props?.countries[country] ?? country);
		});
	}

	const preparePromoLabels = () => {
		const promo_label = (props.promo_labels != undefined) ? props.promo_labels['current'][0] : {};
		if(_size(promo_label) > 0) removeByRole(promo_label, props.roles);
	};

	useEffect(() => {
		preparePromoLabels();
	}, [props.promo_labels]);

	if(promotion === false) return null;

	let date_items = [{
		id:'timezone',
		icon:'knk-geographic-area',
		title:"Timezone",
		value:defaultTimezones(promotion.timezone),
	}, {
		id:'dates',
		icon:'knk-visible',
		title:"Publication",
		value:`<span class="date_range"><span>${EPDateFormat(promotion.start_date, date_format)}</span><span class="with_icon knk-arrow-r-big blueIcon"></span><span>${EPDateFormat(promotion.end_date, date_format)}</span></span>`,
	}];

	if(!is_multistage) {
		date_items.push({
			id:'entry',
			icon:'knk-add-user',
			title:"Entry",
			value:`<span class="date_range"><span>${EPDateFormat(promotion.start_entry, date_format)}</span><span class="with_icon knk-arrow-r-big blueIcon"></span><span>${EPDateFormat(promotion.end_entry, date_format)}</span></span>`,
		});

		if(promotion.votable_entries == 1) {
			date_items.push({
				id:'voting',
				icon:'knk-like',
				title:"Voting",
				value:`<span class="date_range"><span>${EPDateFormat(promotion.start_voting, date_format)}</span><span class="with_icon knk-arrow-r-big blueIcon"></span><span>${EPDateFormat(promotion.end_voting, date_format)}</span></span>`,
			});
		}
	}

	let lang_items = [];
	if(languages.length > 0) {
		let _lang = languages.find((l) => ((l.k == default_lang))).v;
		_lang = (typeof _lang == 'object') ? _lang[Object.keys(_lang)[0]] : _lang
		lang_items.push({
			id:'main_lang',
			icon:'knk-rating',
			title:"Default language",
			value:_lang,
		});
		
		if(is_multilang) {
			const additional_langs = [];
			languages.map((lang) => {
				if(lang.k != default_lang){
					const _lang = (typeof lang.v == 'object') ? lang.v[Object.keys(lang.v)[0]] : lang.v
					additional_langs.push(_lang);
				}
			});

			lang_items.push({
				id:'other_lang',
				icon:'knk-add-item',
				title:"Additional languages",
				value:additional_langs.join(" / "),
			});
		}
	}

	let country_items = [];
	if(!is_basic) {
		country_items.push({
			id:'countries',
			icon:'knk-city',
			title:"Countries of the promotion",
			value:countries_arr.length > 0 ? countries_arr.join(" / ") : i18n("All countries"),
		});
	}

	const default_list_props = {
		maxHeight:'auto',
		padded_items:false,
		linked:false,
		overflowed:false,
	};

	return (
		<>
			<ProfileModule title={{ label:"Promotion dates", icon:'knk-calendar' }}>
				<SimpleListOfItems
					{...default_list_props}
					items={date_items}
				/>
			</ProfileModule>

			{(lang_items.length > 0) && (
				<ProfileModule title={{ label:"Languages", icon:'knk-translate' }}>
					<SimpleListOfItems
						{...default_list_props}
						items={lang_items}
					/>
				</ProfileModule>
			)}

			{(!is_basic) && (
				<ProfileModule title={{ label:"Localization", icon:'knk-geographic-area' }}>
					<SimpleListOfItems
						{...default_list_props}
						items={country_items}
					/>
				</ProfileModule>
			)}
		</>
	);
}

export default injectIntl(PromoDatesResumee);